import React from 'react';
import { useTranslation } from 'next-i18next';
import type { state } from '../../types/store/state';
import { useSelector } from 'react-redux';
import { FooterColumnsTitles, FooterSocialMediaIcon } from './Footer.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faInstagram,
  faYoutube,
  faTiktok, // 1. Importar el ícono de TikTok
} from '@fortawesome/free-brands-svg-icons';

export const FooterBsSocialMedia = () => {
  const { t } = useTranslation();
  const branchStoreDetail = useSelector((state: state) => state.branchStore);

  // Esta función ahora soporta TikTok
  const SocialMediaLinks = (socialMediaName: string) => {
    switch (socialMediaName) {
      case 'facebook':
        return faFacebook;
      case 'instagram':
        return faInstagram;
      case 'youtube':
        return faYoutube;
      case 'tiktok': // 2. Agregar el case para 'tiktok'
        return faTiktok;
      default:
        return null; // Devuelve null si no es un ícono de marca
    }
  };

  return (
    <div>
      <FooterColumnsTitles>{t('footer.sociaMedia.title')}</FooterColumnsTitles>
      <div>
        {/* Lógica refactorizada para los íconos de redes sociales */}
        <p>
          {branchStoreDetail.socialMedia.map((item) => {
            // Obtenemos el ícono directamente
            const icon = SocialMediaLinks(item.name);

            // Si la función devolvió un ícono (no es null), lo renderizamos
            if (icon) {
              return (
                <FooterSocialMediaIcon
                  key={item.id}
                  href={item.url}
                  target="_blank"
                >
                  <FontAwesomeIcon icon={icon as IconProp} height={25} />
                </FooterSocialMediaIcon>
              );
            }
            
            return null;
          })}
        </p>

        <h4>
          {branchStoreDetail.socialMedia.map((branchStoreSocialMedia) => (
            <span key={branchStoreSocialMedia.id}>
              {branchStoreSocialMedia.name === 'phone' ? (
                <FooterSocialMediaIcon
                  href={`tel:${branchStoreSocialMedia.url.replace(
                    /[^0-9]+/g,
                    ''
                  )}`}
                >
                  <br />
                  &#9742;&nbsp;
                  {branchStoreSocialMedia.url}
                </FooterSocialMediaIcon>
              ) : null}
            </span>
          ))}
        </h4>
      </div>
    </div>
  );
};